import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Disclosure } from '@headlessui/react';
import { motion, AnimatePresence } from 'framer-motion';
import NotificationsPopup from '../NotificationPopup';
import DropdownMenu from '../../common/MenuDropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import { signOutUserAction } from '../../actions/auth';
import { detailsPath, trackSupportTicket } from '../../router/roleWisePageRoute';
import { headerCss } from '../../common/Css';
import { closeModalAction, openCustomModal, openFullscreenModal, openTextModalAction } from '../../actions/modal';
import { connectToWebsocket, dicconnectFromWebsocket } from '../../actions/websocket';
import IconToolTip from '../../common/IconToolTip';
import { getChatMainTabs, helpCloseTab, helpOpenTab, helpTab } from '../../pages/chat/ChatController';
import { useNavigatorOnLine, useQuery } from '../../utils/common';
import { websocketConnectionStates } from '../../utils/websocket';
import WhatsappLinkQrPopup from '../../pages/Modals/WhatsappLinkQrPopup';
import { getWhatsappOr, updateWhatsappNumber } from '../../actions/whatsapp';
import Loader from '../../common/Loader';
import { Skeleton } from '@mui/material';
import { isMobileView } from '../../utils/utils';
import UserWorkingStatus from '../UserWorkingStatus';
import BulkFailed from '../../pages/Ticket/Modal/BulkFailed';
import MyAttendance from './MyAttendance';

export const profileComponent = (profileImage) => {
    const defaultPic = process.env.PUBLIC_URL + '/img/default-profile-pic.svg';

    return (
        <motion.div
            className='relative cursor-pointer'
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
        >
            {/* <motion.span
                className='absolute text-green-500 right-0 bottom-0'
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.2 }}
            >
                <svg width='14' height='11'>
                    <circle cx='6' cy='6' r='6' fill='currentColor'></circle>
                </svg>
            </motion.span> */}
            <motion.img
                src={profileImage ? profileImage : defaultPic}
                alt=''
                className='profileImage'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
            />
        </motion.div>
    );
};

export const WebsocketBulb = () => {
    const dispatch = useDispatch();
    const isOnline = useNavigatorOnLine();
    const { websocketConnection } = useSelector((state) => state.websocket);
    const websocketDetails = {
        true: {
            icon: 'signal_cellular_alt',
            iconColr: 'text-scogosuccess',
            hoverMessage: 'Connection Alive',
        },
        false: {
            icon: 'signal_cellular_connected_no_internet_0_bar',
            iconColr: 'text-scogoclosed',
            hoverMessage: 'Disconnected',
        },
    };
    const isConnected = websocketConnection?.readyState === websocketConnectionStates.connected;
    const isLoading = websocketConnection?.readyState === websocketConnectionStates.connecting;
    const [hasConnectedBefore, setHasConnectedBefore] = useState(false);

    const reconnetWebSocket = useCallback(() => {
        if (!isLoading) {
            dispatch(connectToWebsocket({ isReconnecting: true }));
        }
    }, [dispatch, isLoading]);

    useEffect(() => {
        if (isConnected) {
            setHasConnectedBefore(true);
        }
    }, [isConnected])
    useEffect(() => {
        if (isOnline && hasConnectedBefore && !isConnected && !isLoading) {
            dispatch(dicconnectFromWebsocket());
            reconnetWebSocket();
        }
        else if (!isOnline) {
            dispatch(dicconnectFromWebsocket());
        }
    }, [dispatch, isOnline, isConnected, hasConnectedBefore, isLoading, reconnetWebSocket]);
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
        >
            {!isConnected && (
                <IconToolTip title={`Reconnect`}>
                    <motion.span
                        onClick={reconnetWebSocket}
                        className={` ${isLoading ? 'animate-spin cursor-not-allowed' : 'cursor-pointer'} select-none text-font18 material-icons rotate-6`}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    >
                        refresh
                    </motion.span>
                </IconToolTip>
            )}
            <>


                <IconToolTip title={`${websocketDetails[isConnected]?.hoverMessage}`}>
                    <motion.span
                        className={`material-icons text-font18 ml-0 md:ml-2 select-none cursor-pointer ${websocketDetails[isConnected]?.iconColr}`}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    >
                        {websocketDetails[isConnected]?.icon}
                    </motion.span>
                </IconToolTip>
            </>
        </motion.div>
    );
};

const HelpIcon = () => {
    const query = useQuery();
    const navigate = useNavigate();
    let tab = query.get('tab');
    return (
        <IconToolTip title={`Help Chat`}>
            <motion.span
                className={`material-icons text-font18 font-bold mr-2 cursor-pointer rounded-full p-1 ${[helpOpenTab?.path, helpCloseTab.path].includes(tab) ? 'text-scogoorange' : 'hover:text-scogoorange'}`}
                onClick={() => {
                    navigate(`/chats?tab=${helpOpenTab.path}`);
                }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                support_agent
            </motion.span>
        </IconToolTip>
    );
};


const WhatappAlternateMobileIcon = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loggedUser } = useSelector((state) => state.auth);
    const { formButtonLoading } = useSelector((state) => state.loading);
    const formName = "Whatsapp_number_loading"
    return (<>
        {
            formButtonLoading[formName] ?
                <motion.div
                    className='mr-3'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                >
                    <Loader color='#F48A21' size='15' speed='2' thickness='3' marginTop='' />
                </motion.div>
                :
                <IconToolTip title={`Update WhatsApp Number`}>
                    <motion.span
                        className='material-icons text-font18 font-medium mr-2 cursor-pointer rounded-full p-1 text-scogoBasicYellow hover:text-scogoorange'
                        onClick={() => {
                            let payload = {
                                userId: loggedUser?.id,
                                mobileNumber: loggedUser.mobile,
                                verifyType: "PRIMARY",
                                navigate,
                                formName,
                                openModal: true
                            };
                            dispatch(updateWhatsappNumber(payload));
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    >
                        warning
                    </motion.span>
                </IconToolTip>
        }
    </>
    );
};


const WhatappScanIcon = ({ loggedUser }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { whatsappLinkDetails } = useSelector((state) => state.whatsapp)
    const { formButtonLoading } = useSelector((state) => state.loading);
    const formName = "WhatsappQR_number_loading"

    return (
        <>
            {
                formButtonLoading[formName] ?
                    <motion.div
                        className='mr-3'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        <Loader color='#F48A21' size='15' speed='2' thickness='3' marginTop='' />
                    </motion.div> :
                    whatsappLinkDetails?.status === 1 ?
                        <IconToolTip title={`WhatsApp Connected`}>
                            <motion.span
                                className='text-font18 mr-2 cursor-pointer'
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <motion.img
                                    src={process.env.PUBLIC_URL + "/img/whatsapp.png"}
                                    alt=""
                                    className='w-8'
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                />
                            </motion.span>
                        </IconToolTip>
                        :
                        <IconToolTip title={`Connect your whatsapp`}>
                            <motion.span
                                className='text-font18  hover:text-scogoorange mr-2 cursor-pointer'
                                onClick={() => {
                                    if (loggedUser?.is_mobile_linked_with_whatsapp === 0) {
                                        let payload = {
                                            userId: loggedUser?.id,
                                            mobileNumber: loggedUser.mobile,
                                            verifyType: "PRIMARY",
                                            navigate,
                                            formName,
                                            openModal: true
                                        };
                                        dispatch(updateWhatsappNumber(payload));
                                    } else {
                                        dispatch(
                                            openCustomModal({
                                                heading: `Connect Your WhatsApp`,
                                                modalWidth: '32vw',
                                                modalHeight: 'auto',
                                                modalComponent: <WhatsappLinkQrPopup />,
                                                headerComponent: <div className='flex items-center gap-2' >

                                                    <IconToolTip title="Refresh" onClick={() => {
                                                        dispatch(getWhatsappOr({ openModal: true }))
                                                    }}>
                                                        <motion.span
                                                            className='material-icons text-scogoprimary font-medium align-middle text-4xl hover:text-scogoorange cursor-pointer'
                                                            whileHover={{ scale: 1.1 }}
                                                            whileTap={{ scale: 0.9 }}
                                                        >
                                                            refresh
                                                        </motion.span>
                                                    </IconToolTip>
                                                </div>,
                                            })
                                        );
                                    }
                                }}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <motion.img
                                    src={process.env.PUBLIC_URL + "/img/whatsapp.png"}
                                    alt=""
                                    className='w-8'
                                    style={{ filter: "saturate(0%)" }}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                />
                            </motion.span>
                        </IconToolTip>
            }
        </>
    );
};

const Header = ({ isInactiveUser = false }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { newLoggedUserData } = useSelector((state) => state.auth);
    const ticketProgress = useSelector((state) => state.serviceRequest.ticketProgress)

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    const handleMyDocumentsClick = () => {
        // if (!loggedUser.document_folder_id) {
        //     dispatch(createRootFolder(loggedUser.id, navigate));
        // } else {
        //     navigate(`/documents?path=/${loggedUser.document_folder_id}`);
        // }
    };

    const handleMyProfileClick = () => {
        navigate('/user-profile');
    };


    const getAcionDropdown = () => {
        let actions = [];
        // let myDocuments = {
        //     menuName: 'My Documents',
        //     menuIcon: 'folder',
        //     onClick: () => {
        //         handleMyDocumentsClick();
        //     },
        // };
        let logout = {
            menuName: 'Sign out',
            menuIcon: 'logout',
            onClick: (item, dispatch) => {
                return dispatch(
                    openTextModalAction({
                        heading: 'Sign Out',
                        text: 'Are you sure you want to sign out?',
                        formName: 'logout',
                        buttons: [
                            {
                                showLoading: true,
                                textOrComponent: 'Yes',
                                type: 'red',
                                buttonClass: 'hover:bg-scogoLightFillRed',
                                onClick: () => {
                                    dispatch(signOutUserAction(navigate));
                                },
                            },
                            {
                                textOrComponent: 'No',
                                type: 'blue',
                                onClick: () => {
                                    closeModal();
                                },
                            },
                        ],
                        closeOnBackdropClick: false,
                    })
                );
            },
        };
        let myProfile = {
            menuName: 'My Profile',
            menuIcon: 'person',
            onClick: () => {
                handleMyProfileClick();
            },
        };
        let myAttendance = {
            menuName: 'My Attendance',
            menuIcon: 'today',
            onClick: () => {
                dispatch(openCustomModal({
                    heading: 'My Attendance',
                    modalComponent: <MyAttendance />,
                    modalWidth: '50rem',
                    modalHeight: 'auto',
                }));
            },
        };
        if (isInactiveUser) actions = [logout];
        else actions = [myProfile, myAttendance, logout];
        return actions;
    };

    const chatTabs = useMemo(() => getChatMainTabs(), []);
    const showHelp = chatTabs.findIndex((tab) => tab.tabID === helpTab.tabID) >= 0;
    // const showWhatappAlternateMobile = loggedUser.is_mobile_linked_with_whatsapp === 0;
    // const showWhatsappQr = isScm(role, type);
    const { isUIConfigLoading } = useSelector(state => state.loading);
    const onBulkClick = () => {
        if (ticketProgress?.payload?.failed?.length > 0) {
            dispatch(
                openFullscreenModal({
                    heading: 'Failed Tickets ',

                    modalComponent: <BulkFailed ticketProgress={ticketProgress} type={ticketProgress?.payload?.type} name={'Ticket'} />
                })
            )
        }
    }
    return (
        <Disclosure as='div' className='header fixed  w-full z-50 flex items-center justify-between  '>
            {({ open }) => (
                <>
                    <motion.div
                        className={`${headerCss?.mainDiv} w-full flex items-center justify-between `}
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <motion.div
                            className='flex items-center cursor-pointer justify-center '
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <div className='shrink-0'>
                                {isUIConfigLoading ?
                                    <Skeleton variant='rectangular' animation='wave' height='3rem' width='5rem' />
                                    : <HeaderLogo />}
                            </div>
                        </motion.div>
                        <motion.div
                            className='md:block'
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.3, delay: 0.2 }}
                        >
                            <div className='ml-4 flex items-center md:ml-6'>
                                <AnimatePresence>
                                    {ticketProgress?.payload?.failed?.length > 0 && (
                                        <motion.div
                                            className='bg-red-500 cursor-pointer text-white px-2 py-1 rounded-lg mr-2 shadow-sm flex items-center justify-center'
                                            animate={{
                                                boxShadow: ['0 0 0 rgba(239, 68, 68, 0.4)', '0 0 15px rgba(239, 68, 68, 0.7)', '0 0 0 rgba(239, 68, 68, 0.4)'],
                                                scale: [1, 1.05, 1]
                                            }}
                                            transition={{
                                                duration: 1.5,
                                                repeat: Infinity,
                                                repeatType: "loop"
                                            }}
                                            whileHover={{
                                                scale: 1.1,
                                                backgroundColor: '#ef4444'
                                            }}
                                            whileTap={{ scale: 0.95 }}
                                        >
                                            <span className="mr-1">
                                                <i className="material-icons text-sm">error_outline</i>
                                            </span>
                                            <span className="font-medium" onClick={onBulkClick}>Bulk Failed</span>
                                        </motion.div>
                                    )}
                                    {newLoggedUserData.user.is_onboarded && (
                                        <UserWorkingStatus />
                                    )}
                                    {!isInactiveUser && (
                                        <>
                                            {/* <CallQueueList /> */}
                                            {/* {showWhatappAlternateMobile && <WhatappAlternateMobileIcon />} */}
                                            {/* {showWhatsappQr && <WhatappScanIcon loggedUser={loggedUser} />} */}
                                            {showHelp && <HelpIcon />}
                                            {/* <WebsocketBulb /> */}
                                            {/* <NotificationsPopup /> */}

                                        </>
                                    )}

                                </AnimatePresence>
                                <motion.div
                                    className='w-[3rem]'
                                    whileHover={{ scale: 1.05 }}
                                >
                                    <IconToolTip title={newLoggedUserData ? `${newLoggedUserData.user.full_name}` : ''}>
                                        <DropdownMenu
                                            menuData={getAcionDropdown()}
                                            componentOrIcon={() => profileComponent(newLoggedUserData.user.avatar_link)}
                                            iconColor={'text-scogoprimary'}
                                        />
                                    </IconToolTip>
                                </motion.div>
                            </div>
                        </motion.div>
                    </motion.div>
                </>
            )}
        </Disclosure>
    );
};

export default Header;


export const HeaderLogo = () => {
    const { uiConfig } = useSelector(state => state.user);
    const { ticketDetails } = useSelector((state) => state.tickets);
    const { tagAssetDetails } = useSelector((state => state.inventory));
    const location = useLocation();
    let url = process.env.PUBLIC_URL + '/img/scogo-logo-black-1.png';
    if (uiConfig) url = uiConfig.logoUrl;
    else if (isMobileView) {
        url = process.env.PUBLIC_URL + '/img/scogo_logo_without_scogo.png'
    }
    let additionalClass = 'headerLogo max-w-max';
    const smart_edge_router_asset_id = 695;
    let isSmartEdgeRouter = [parseInt(tagAssetDetails?.assetType), parseInt(tagAssetDetails?.assetType?.id)].includes(smart_edge_router_asset_id);
    if (ticketDetails && ticketDetails.assets) {
        isSmartEdgeRouter = ticketDetails.assets.find((asset) => asset.asset_type_id === smart_edge_router_asset_id);
    }
    if ([detailsPath.path, trackSupportTicket.path].includes(location.pathname) && (isSmartEdgeRouter)) {
        url = process.env.PUBLIC_URL + '/img/ser_logo.png';
        additionalClass = 'h-10 w-40 min-w-40'
    };
    return (
        <motion.img
            className={additionalClass}
            src={url}
            alt='Company Logo'
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.05 }}
        />
    )
}